import { v4 as uuidv4 } from 'uuid';
import cookie from 'vue-cookies';

const player = cookie.get('player'); // The player cookie
const colours = require('@/assets/colours.json'); // The available colours
const randomColour = colours[Math.floor(Math.random() * colours.length)].hex; // Get a random colour

export const state = {
    player_id: player ? player.player_id : uuidv4(),
    name: player ? player.name : '',
    colour: player ? player.colour : randomColour,
};

export const mutations = {
    /**
     * Set multiple user attribute states
     * @param {Object} state - The state object
     * @param {Object} attributes - The attributes to set
     */
    SET_USER_ATTRIBUTES(state, attributes) {
        Object.entries(attributes).forEach((attribute) => {
            state[attribute[0]] = attribute[1];
        });
    },
};

export const getters = {
    /**
     * Get user state
     * @param {object} state - The state object
     * @param {String} key - The attribute key
     */
    GET_USER_ATTRIBUTE: (state) => (key) => {
        return state[key];
    },
};

export const actions = {
    /**
     * Set the user in state and cookie
     * @param {Object} player
     */
    SET_USER({ commit }, player) {
        return new Promise((resolve) => {
            window.$cookies.set('player', player);
            commit('SET_USER_ATTRIBUTES', player);
            resolve();
        });
    },
};
